import axios from "axios";
import { addErrorInterceptors, defaultAxiosSettings } from "@/api/axiosConfigs/defaultAxiosConfig";

export const newAxiosInstance = addErrorInterceptors(
  axios.create({
    baseURL: process.env.VUE_APP_NEW_API_URL,
    ...defaultAxiosSettings,
  })
);